export const categories = [
  {
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '聚焦网红圈最新黑料，第一时间追踪爆料现场，让您吃瓜不落人后。',
    icon: 'ri-spy-line',
    featured: true,
    banner: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20scene%20with%20smartphone%20and%20ring%20light%2C%20modern%20studio%20setup%2C%20warm%20ambient%20lighting%2C%20content%20creator%20aesthetic%2C%20clean%20minimal%20composition%2C%20professional%20photography&width=1200&height=400&seq=category-wanghong-heiliao-banner&orientation=landscape',
  },
  {
    slug: 'mingxing-tafang',
    name: '明星塌房',
    description: '明星人设崩塌全记录，从顶流到翻车，完整还原每一个塌房瞬间。',
    icon: 'ri-building-2-line',
    featured: true,
    banner: 'https://readdy.ai/api/search-image?query=Empty%20red%20carpet%20leading%20to%20a%20dark%20stage%2C%20dramatic%20theatrical%20lighting%2C%20celebrity%20scandal%20concept%2C%20cinematic%20photography%2C%20warm%20and%20dark%20contrast%2C%20professional%20aesthetic&width=1200&height=400&seq=category-mingxing-tafang-banner&orientation=landscape',
  },
  {
    slug: 'dujia-xianchang',
    name: '独家现场',
    description: '独家一手现场报道，深度还原事件真相，做最真实的吃瓜群众。',
    icon: 'ri-camera-line',
    featured: true,
    banner: 'https://readdy.ai/api/search-image?query=Professional%20camera%20on%20tripod%20at%20a%20press%20event%2C%20dramatic%20spotlight%20lighting%2C%20photojournalism%20aesthetic%2C%20clean%20minimal%20composition%2C%20breaking%20news%20concept%2C%20warm%20tones&width=1200&height=400&seq=category-dujia-xianchang-banner&orientation=landscape',
  },
  {
    slug: 'remen-zhuizong',
    name: '热门追踪',
    description: '实时追踪全网最热话题，从发酵到爆发，全程记录每一个关键节点。',
    icon: 'ri-fire-line',
    featured: false,
    banner: 'https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20glowing%20headlines%2C%20modern%20digital%20newsroom%2C%20warm%20amber%20and%20coral%20accents%2C%20dynamic%20composition%2C%20real%20time%20tracking%20aesthetic%2C%20professional%20style&width=1200&height=400&seq=category-remen-zhuizong-banner&orientation=landscape',
  },
  {
    slug: 'shendu-baodao',
    name: '深度报道',
    description: '深度挖掘事件背后真相，专业解读娱乐生态，不止吃瓜更懂瓜。',
    icon: 'ri-file-text-line',
    featured: false,
    banner: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20desk%20with%20documents%20and%20magnifying%20glass%2C%20dramatic%20lighting%2C%20deep%20investigation%20concept%2C%20professional%20aesthetic%2C%20warm%20amber%20accents%2C%20clean%20minimal%20composition&width=1200&height=400&seq=category-shendu-baodao-banner&orientation=landscape',
  },
];

export const articles = [
  {
    id: 1,
    title: '某千万粉丝网红被曝偷税漏税，金额高达数千万',
    summary: '据知情人士透露，该网红通过多个壳公司转移收入，目前税务部门已介入调查，账号疑似被限流。',
    content: `<p>近日，一位拥有超过两千万粉丝的头部网红被曝涉嫌偷税漏税，引发全网热议。</p><p>据接近税务部门的知情人士透露，该网红长期通过多个壳公司进行收入转移，累计偷逃税款金额可能高达数千万元。目前，相关税务部门已经正式介入调查。</p><p>值得注意的是，该网红的社交媒体账号近日出现异常——多条视频播放量骤降，疑似被平台限流处理。有网友发现，其最新发布的内容点赞数从平时的百万级别暴跌至不足十万。</p><p>业内人士分析认为，近年来监管部门对网红经济的税收监管日益严格，此次事件或将成为行业整顿的标志性案例。此前已有数位头部主播因税务问题被处罚，最高者补税加罚款超过亿元。</p><p>目前，该网红团队尚未对此事作出正式回应，其工作室电话一直处于无人接听状态。我们将持续关注事件进展。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20news%20scene%20of%20a%20social%20media%20influencer%20studio%20with%20dim%20lighting%2C%20laptop%20and%20camera%20equipment%20on%20a%20minimal%20desk%2C%20moody%20atmosphere%20with%20warm%20amber%20accents%2C%20cinematic%20photography%20style%2C%20clean%20background%20with%20soft%20shadows%2C%20editorial%20quality&width=800&height=500&seq=article-wanghong-tax-2026&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-06',
    readCount: 128300,
    tags: ['偷税漏税', '网红', '税务调查'],
    featured: true,
    exclusive: true,
  },
  {
    id: 2,
    title: '顶流男星深夜密会神秘女子，粉丝集体破防',
    summary: '有媒体拍到某顶流男星深夜与一神秘女子亲密同行，两人举止暧昧，疑似新恋情曝光。',
    content: `<p>昨日深夜，有娱乐媒体拍到某顶流男星与一名神秘女子在北京某高档小区附近亲密同行的画面，引发粉丝圈大地震。</p><p>据拍摄者描述，两人从一辆黑色商务车下来后，该男星十分自然地牵起了女子的手，两人有说有笑地走进了一栋高级公寓。整个过程中，男星并未佩戴口罩或帽子等遮掩物，似乎并不在意被认出。</p><p>消息一出，该男星的粉丝群体迅速分裂为两派。一部分粉丝表示"祝福哥哥找到真爱"，而另一部分则直接破防，在超话中刷屏脱粉宣言。截至目前，相关话题阅读量已突破5亿。</p><p>该男星工作室暂未对此事发表任何声明。有圈内人士透露，两人其实已经交往超过半年，只是一直没有公开。女方据传是圈外人，从事金融行业。</p><p>我们将继续追踪事件的最新进展。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Night%20street%20scene%20in%20upscale%20Beijing%20neighborhood%2C%20blurry%20paparazzi%20style%20photography%2C%20two%20silhouettes%20walking%20together%20under%20warm%20street%20lamps%2C%20cinematic%20noir%20atmosphere%2C%20luxury%20apartment%20building%20in%20background%2C%20moody%20and%20mysterious%20vibe&width=800&height=500&seq=article-celeb-dating-2026&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-05',
    readCount: 356700,
    tags: ['恋情曝光', '顶流男星', '粉丝破防'],
    featured: true,
    exclusive: false,
  },
  {
    id: 3,
    title: '某知名综艺节目录制现场爆发激烈冲突',
    summary: '某卫视王牌综艺录制过程中，两位嘉宾因观点不合爆发激烈争吵，导演紧急叫停录制。',
    content: `<p>今日下午，某卫视王牌综艺节目在录制最新一期时突发意外——两位常驻嘉宾因某个游戏环节的观点分歧爆发了激烈冲突。</p><p>据现场工作人员透露，冲突起因是一个关于价值观的选择题。两位嘉宾各持己见，从最初的理性讨论逐渐升级为情绪化争吵，最后甚至出现了肢体推搡的苗头。导演组紧急叫停了录制，并将两位嘉宾分别带到不同休息室进行安抚。</p><p>现场观众表示，冲突发生时场面一度十分尴尬，其他嘉宾面面相觑不知如何是好。有观众偷偷用手机录下了部分片段并上传至社交平台，但很快被删除。</p><p>节目组随后发布声明称"录制过程中出现了一些小插曲，已妥善解决，节目将按计划播出"。但多位业内人士透露，该期节目很可能会进行大量后期剪辑处理，甚至不排除重新录制的可能。</p><p>这并非该节目首次出现嘉宾冲突事件。去年就曾有两位飞行嘉宾因游戏规则问题产生不愉快，但当时并未发展到如此激烈的程度。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20TV%20variety%20show%20studio%20with%20professional%20lighting%20rigs%2C%20cameras%20and%20equipment%2C%20tense%20atmosphere%2C%20warm%20studio%20lights%20contrasting%20with%20dark%20background%2C%20cinematic%20documentary%20style%2C%20clean%20composition&width=800&height=500&seq=article-show-conflict-2026&orientation=landscape',
    author: '现场特派员',
    publishDate: '2026-07-06',
    readCount: 89200,
    tags: ['综艺', '嘉宾冲突', '录制事故'],
    featured: true,
    exclusive: true,
  },
  {
    id: 4,
    title: '女星整容前后对比照曝光，网友直呼认不出',
    summary: '有网友扒出某当红女星十年前的照片与现在对比，五官变化明显，引发整容质疑。',
    content: `<p>近日，一组某当红女星的十年前后对比照片在网络上疯传，引发网友对其是否整容的热烈讨论。</p><p>对比照片显示，该女星十年前的照片中，鼻梁较为扁平，下巴偏短，整体面部轮廓与现在判若两人。而如今，她拥有高挺的鼻梁、尖翘的下巴和精致的V字脸，变化之大令许多网友直呼"完全认不出"。</p><p>有整形医生匿名分析称，从照片来看，该女星很可能接受了鼻综合、下颌角磨骨以及面部脂肪填充等多个项目。不过，也有粉丝力挺偶像，称这些变化纯属"长开了"和化妆技术的进步。</p><p>截至目前，该女星本人尚未对此事作出回应。但细心的网友发现，她最近发布的照片开始更多地展示侧脸，似乎在刻意回避正面特写。</p><p>娱乐圈整容话题一直是公众关注的焦点。此前已有多位明星因整容质疑而陷入舆论漩涡，有的选择大方承认，有的则一直保持沉默。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Split%20comparison%20concept%20with%20soft%20beauty%20clinic%20aesthetic%2C%20minimal%20and%20clean%20background%2C%20warm%20neutral%20tones%2C%20elegant%20editorial%20photography%2C%20soft%20diffused%20lighting%2C%20professional%20studio%20setup&width=800&height=500&seq=article-plastic-surgery-2026&orientation=landscape',
    author: '娱乐观察员',
    publishDate: '2026-07-04',
    readCount: 215400,
    tags: ['整容', '女星', '对比照'],
    featured: false,
    exclusive: false,
  },
  {
    id: 5,
    title: '独家：某选秀节目暗箱操作内幕曝光',
    summary: '前工作人员实名爆料，某大型选秀节目存在严重的暗箱操作，排名早已内定。',
    content: `<p>日前，一位自称曾在某大型选秀节目制作团队工作的人员通过社交媒体实名爆料，揭露了该节目存在的一系列暗箱操作行为。</p><p>据该爆料人透露，节目的最终排名在录制前就已经基本确定。制作方会根据选手背后的经纪公司资源、商业价值等因素进行综合考量，"观众投票只不过是个形式"。爆料人还提供了多张内部聊天记录截图作为证据。</p><p>更令人震惊的是，爆料人称有些选手的"感人故事"完全是编剧团队凭空编造出来的。"那个说自己从小父母双亡的选手，其实父母都健在，而且家庭条件相当不错。"</p><p>消息传出后，多位曾参加该节目的选手纷纷在评论区留言表示支持爆料人。有选手称"终于有人说出来了"，还有选手表示自己在节目期间就发现了诸多不公。</p><p>目前，该节目制作方尚未对此作出回应。但多个品牌赞助商已经开始内部评估是否继续合作。业内人士预测，这次爆料可能引发选秀行业的大规模整顿。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20a%20talent%20show%20with%20dramatic%20spotlights%20casting%20long%20shadows%2C%20empty%20stage%20with%20microphone%20stand%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20and%20cool%20contrast%2C%20documentary%20photography%20style&width=800&height=500&seq=article-talent-show-2026&orientation=landscape',
    author: '深度调查组',
    publishDate: '2026-07-03',
    readCount: 467800,
    tags: ['选秀', '暗箱操作', '实名爆料'],
    featured: true,
    exclusive: true,
  },
  {
    id: 6,
    title: '知名导演被多名女演员指控骚扰，圈内震动',
    summary: '一周内已有五位女演员公开指控某知名导演存在不当行为，该导演所有合作项目已暂停。',
    content: `<p>一场席卷影视圈的#MeToo风暴正在发酵。过去一周内，已有五位女演员通过社交媒体或接受采访的方式，公开指控某知名导演存在骚扰及不当行为。</p><p>第一位站出来的女演员在长文中详细描述了2019年在一部电影试镜过程中遭遇的不愉快经历。随后，更多女演员纷纷跟进，指控内容涉及言语骚扰、不当肢体接触等多方面。</p><p>事件发酵后，该导演参与的所有正在推进的合作项目已被投资方紧急叫停。其所属的导演协会发表声明称"将严肃对待此事，并启动调查程序"。</p><p>多位圈内人士表示，这次事件对整个行业是一次重要的警示。"希望更多受害者能够勇敢发声，也希望行业能够真正建立起有效的保护机制。"</p><p>该导演本人通过律师发表声明，否认所有指控，并表示将通过法律途径维护自身权益。但舆论已经明显偏向指控方。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20of%20an%20empty%20directors%20chair%20on%20a%20dark%20film%20set%2C%20spotlight%20on%20the%20chair%2C%20surrounding%20darkness%2C%20powerful%20symbolic%20imagery%2C%20warm%20key%20light%2C%20professional%20film%20production%20environment&width=800&height=500&seq=article-metoo-director-2026&orientation=landscape',
    author: '深度调查组',
    publishDate: '2026-07-02',
    readCount: 532100,
    tags: ['导演', '骚扰指控', 'MeToo'],
    featured: false,
    exclusive: false,
  },
  {
    id: 7,
    title: '某短视频平台头部主播直播翻车，百万观众见证',
    summary: '某拥有3000万粉丝的带货主播在直播中产品出现严重质量问题，现场演示直接"打脸"。',
    content: `<p>昨晚，一场让百万观众目瞪口呆的直播翻车事故在短视频平台上演。某拥有超过3000万粉丝的头部带货主播在推荐一款号称"摔不坏"的手机壳时，现场演示环节出现了灾难性场面。</p><p>当时该主播信心满满地将手机从约一米五的高度摔向地面，本应毫发无损的手机屏幕却当场碎裂。直播间瞬间炸锅，弹幕刷屏"翻车了""打脸来得太快"。主播当场愣住数秒，随后勉强挤出笑容称"这是意外情况"。</p><p>更糟糕的是，随后有购买了该产品的消费者在评论区晒出大量差评，称该手机壳"轻轻一碰就裂了""跟直播说的完全不一样"。该品牌方连夜发布道歉声明，承诺全额退款。</p><p>直播带货行业近年来翻车事件频发，但由头部主播亲自上演"现场打脸"的情况并不多见。有业内人士分析，这反映出部分主播在选品环节存在严重失职，过度追求佣金而忽视产品质量审核。</p><p>该主播今日凌晨发布道歉视频，表示将全面整改选品流程，并对所有购买该产品的消费者进行额外补偿。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20professional%20ring%20light%2C%20smartphone%20on%20tripod%2C%20product%20display%20table%2C%20modern%20minimal%20aesthetic%2C%20warm%20ambient%20lighting%2C%20clean%20white%20and%20wood%20tones%2C%20content%20creator%20workspace&width=800&height=500&seq=article-livestream-fail-2026&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-01',
    readCount: 389200,
    tags: ['直播翻车', '带货', '产品质量'],
    featured: false,
    exclusive: false,
  },
  {
    id: 8,
    title: '年度最甜CP疑似分手，双方社交账号取关',
    summary: '被粉丝称为"年度最甜CP"的两位艺人被发现互相取关社交账号，删除所有合照。',
    content: `<p>曾被粉丝称为"年度最甜CP"的两位当红艺人，近日被眼尖的网友发现已经互相取关了社交平台账号，并且删除了所有与对方相关的合照和互动内容。</p><p>这对CP因去年合作的一部热播剧结缘，戏里戏外的甜蜜互动让粉丝嗑得如痴如醉。两人不仅在社交媒体上频繁互动，还多次被拍到私下约会的画面。然而，最近三个月来，两人的公开互动明显减少。</p><p>有知情人士透露，两人实际上已经分手超过两个月，原因是"工作太忙聚少离多"。但这一说法遭到部分粉丝质疑，有粉丝扒出两人近期的行程其实有大量重合。</p><p>CP粉纷纷表示心碎，相关超话中充斥着"再也不相信爱情了""我的CP be了"等留言。但也有理智粉呼吁大家尊重艺人的私生活选择。</p><p>截至目前，两位当事人均未对此事作出公开回应。其经纪公司也表示"艺人的私人事务不便评论"。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Two%20empty%20chairs%20facing%20away%20from%20each%20other%20in%20a%20romantic%20sunset%20setting%2C%20warm%20golden%20hour%20light%2C%20emotional%20and%20melancholic%20atmosphere%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20elegant%20editorial%20style&width=800&height=500&seq=article-cp-breakup-2026&orientation=landscape',
    author: '娱乐观察员',
    publishDate: '2026-06-30',
    readCount: 276500,
    tags: ['CP分手', '取关', '恋情告急'],
    featured: false,
    exclusive: false,
  },
  {
    id: 9,
    title: '深度：流量明星的"数据注水"产业链揭秘',
    summary: '调查发现，一条完整的流量数据造假产业链已经形成，从微博转评赞到音乐平台播放量均可"购买"。',
    content: `<p>在流量为王的时代，一组漂亮的数据往往意味着更高的商业价值和更好的资源。然而，这些看似惊人的数据背后，究竟有多少是真实有效的？</p><p>经过为期一个月的深入调查，我们发现了一条完整且成熟的流量数据造假产业链。从微博的转发评论点赞，到音乐平台的播放量和下载量，再到视频平台的观看数据，几乎所有可以量化的指标都有明码标价的"优化服务"。</p><p>记者以经纪人身份联系了多家数据优化服务商。其中一家报价：微博100万转发仅需8000元，某音乐平台100万播放量只需5000元。服务商甚至提供"自然增长"套餐，让数据增长曲线看起来更加真实可信。</p><p>更令人担忧的是，这种现象已经严重扭曲了整个行业的评价体系。一位不愿透露姓名的制片人告诉记者："现在选角时，我们已经不太敢单纯看数据了，因为根本分不清哪些是真实的热度。"</p><p>多位业内人士呼吁平台方加强数据反作弊措施，同时建议品牌方建立更科学的代言人评估体系，从根本上解决数据注水的问题。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20data%20visualization%20with%20floating%20numbers%20and%20charts%2C%20dark%20technological%20background%20with%20warm%20amber%20accent%20lights%2C%20cyber%20aesthetic%2C%20clean%20minimal%20composition%2C%20data%20analytics%20concept%2C%20modern%20corporate%20style&width=800&height=500&seq=article-data-fraud-2026&orientation=landscape',
    author: '深度调查组',
    publishDate: '2026-06-29',
    readCount: 198400,
    tags: ['数据造假', '流量明星', '产业链'],
    featured: false,
    exclusive: true,
  },
  {
    id: 10,
    title: '某品牌代言人翻车后，品牌方连夜撤广告',
    summary: '因代言人突发负面新闻，多个品牌连夜下架相关广告物料，预估损失超千万。',
    content: `<p>代言人一出事，品牌方比谁都急。近日，因某代言人突发严重负面新闻，与其合作的多个品牌开启了"连夜撤广告"模式。</p><p>据不完全统计，至少有6个品牌在负面新闻爆出后的24小时内下架了与该代言人相关的所有线上广告物料。多个城市的地铁站、商场大屏的户外广告也被紧急替换。有广告业内人士估算，仅广告物料更换一项，各品牌的直接损失合计已超过千万元。</p><p>其中损失最惨重的是一家即将发布新品的手机品牌。该品牌原本计划在本周末举办大型新品发布会，代言人将作为重磅嘉宾出席。如今不仅需要紧急更换所有宣传物料，发布会流程也需要全面调整。</p><p>近年来，明星代言人翻车事件频发，给品牌方敲响了警钟。越来越多的品牌开始在代言合同中加入"道德条款"，约定代言人如因个人行为造成负面影响需承担相应赔偿。</p><p>法律界人士表示，品牌方的这种做法值得肯定，但更重要的是建立更完善的事前尽调机制，从源头上降低风险。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Empty%20billboard%20being%20taken%20down%20in%20a%20modern%20city%20street%2C%20urban%20night%20scene%20with%20neon%20lights%2C%20professional%20workers%20silhouette%2C%20dramatic%20cinematic%20lighting%2C%20clean%20composition%2C%20corporate%20crisis%20concept&width=800&height=500&seq=article-brand-crisis-2026&orientation=landscape',
    author: '娱乐观察员',
    publishDate: '2026-06-28',
    readCount: 145600,
    tags: ['代言翻车', '品牌危机', '广告撤换'],
    featured: false,
    exclusive: false,
  },
  {
    id: 11,
    title: '网红餐厅被曝使用过期食材，后厨卫生触目惊心',
    summary: '一家在社交平台拥有超高人气的网红餐厅被暗访记者拍到使用过期食材，厨房卫生状况堪忧。',
    content: `<p>近日，一家在各大社交平台拥有超高人气的网红餐厅被暗访记者曝光存在严重的食品安全问题。</p><p>暗访画面显示，该餐厅后厨环境令人触目惊心：过期三个月的调味料仍在正常使用，蟑螂在切菜板上爬行，洗碗池的水已经发黑却仍在重复使用。更令人震惊的是，一些标注"当日新鲜"的食材实际已经存放超过一周。</p><p>这家餐厅以其精致的摆盘和"ins风"装修闻名，是众多年轻人打卡拍照的热门地点。在某点评平台上，该餐厅评分高达4.8分，排队等位通常需要两小时以上。</p><p>视频曝光后，当地市场监管部门已对该餐厅进行突击检查，并责令其停业整顿。该餐厅老板发布道歉视频，称"管理疏忽"，但网友并不买账，"平时收那么贵的餐费，连基本的卫生都做不好"。</p><p>此事件再次引发公众对网红餐饮行业的信任危机。营养专家提醒消费者，选择餐厅时不能只看颜值和热度，食品安全才是第一位的。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Dark%20and%20messy%20commercial%20kitchen%20with%20dramatic%20lighting%2C%20stainless%20steel%20surfaces%2C%20contrast%20between%20clean%20front%20and%20dirty%20back%20area%2C%20investigative%20journalism%20style%2C%20cinematic%20documentary%20photography%2C%20warm%20and%20cool%20lighting%20mix&width=800&height=500&seq=article-restaurant-hygiene-2026&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-06-27',
    readCount: 312800,
    tags: ['网红餐厅', '食品安全', '过期食材'],
    featured: false,
    exclusive: true,
  },
  {
    id: 12,
    title: '知名音乐人被控抄袭，多首热门歌曲疑似"借鉴"',
    summary: '有音乐人发布对比视频，指控某知名音乐制作人多首热门歌曲涉嫌抄袭海外作品。',
    content: `<p>一场关于音乐抄袭的争论正在华语乐坛激烈展开。日前，一位独立音乐人发布了一系列对比视频，指控某知名音乐制作人的多首热门歌曲涉嫌抄袭海外作品。</p><p>对比视频中，该制作人的歌曲与多首海外歌曲在旋律走向、和声编排以及编曲风格上存在高度相似。其中最明显的一首，副歌部分的旋律几乎与一首三年前的韩国歌曲完全一致，仅做了些许节奏调整。</p><p>该视频迅速引发热议，话题阅读量在24小时内突破3亿。多位专业音乐人也加入讨论，有音乐制作人表示："这不是简单的风格相似，而是旋律的实质性雷同。"但也有人认为，在流行音乐中，某些旋律走向的相似是难免的。</p><p>被指控的制作人通过工作室发表声明，否认抄袭指控，称"所有作品均为独立创作，不排除采取法律手段维权"。但紧接着，又有网友扒出了更多疑似抄袭案例。</p><p>法律专家表示，音乐抄袭的认定在司法实践中较为复杂，需要专业鉴定机构进行旋律比对。但无论如何，这次事件已经在行业内引发了关于原创精神的深刻反思。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20professional%20recording%20equipment%2C%20mixing%20console%2C%20headphones%2C%20warm%20studio%20lighting%2C%20creative%20workspace%2C%20modern%20minimal%20aesthetic%2C%20professional%20audio%20production%20environment&width=800&height=500&seq=article-music-plagiarism-2026&orientation=landscape',
    author: '深度调查组',
    publishDate: '2026-06-26',
    readCount: 167900,
    tags: ['音乐抄袭', '版权争议', '热门歌曲'],
    featured: false,
    exclusive: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

export const comments = [
  {
    id: 1,
    articleId: 5,
    user: '吃瓜群众老王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20Chinese%20man%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20corporate%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-wang-2026&orientation=squarish',
    content: '早就觉得这个节目有问题了！每次淘汰的都是实力强的选手，留下的都是带资进组的。这次终于有人站出来爆料了，支持！',
    date: '2026-07-03',
  },
  {
    id: 2,
    articleId: 5,
    user: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20person%2C%20serious%20expression%2C%20clean%20white%20background%2C%20modern%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-jiwei-2026&orientation=squarish',
    content: '实名爆料是真的勇！希望相关部门能够介入调查，给所有选手一个公平公正的环境。选秀不应该是资本的玩物。',
    date: '2026-07-04',
  },
  {
    id: 3,
    articleId: 5,
    user: '佛系追星人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%2C%20calm%20expression%2C%20clean%20white%20background%2C%20natural%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-foxi-2026&orientation=squarish',
    content: '不意外，选秀节目本来就是一场秀。只是没想到连选手的身世都是编的，这个确实有点过分了。',
    date: '2026-07-04',
  },
  {
    id: 4,
    articleId: 8,
    user: 'CP已死有事烧纸',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20person%20with%20emotional%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-cp-2026&orientation=squarish',
    content: '我的CP真的be了……从他们合作那部剧就开始嗑，嗑了整整一年，没想到是这个结局。尊重吧，但还是好难过。',
    date: '2026-06-30',
  },
  {
    id: 5,
    articleId: 6,
    user: '正义路人甲',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20person%2C%20determined%20expression%2C%20clean%20white%20background%2C%20corporate%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-zhengyi-2026&orientation=squarish',
    content: '五位女演员同时站出来，这已经不能简单用"误会"来解释了。希望法律能给出公正的裁决。',
    date: '2026-07-03',
  },
];

export const testimonials = [
  {
    id: 1,
    outlet: '娱乐周刊',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20magazine%20logo%20design%20with%20Chinese%20typography%2C%20clean%20white%20background%2C%20modern%20editorial%20style%2C%20professional%20brand%20identity&width=200&height=80&seq=logo-yulezhoukan-2026&orientation=landscape',
    quote: '五一吃瓜网以其快速、准确、深度的报道，已成为中文娱乐资讯领域不可忽视的力量。',
    date: '2026年6月',
  },
  {
    id: 2,
    outlet: '新媒体观察',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20media%20company%20logo%20design%20with%20modern%20Chinese%20typography%2C%20clean%20white%20background%2C%20tech%20style%2C%20professional%20brand%20identity&width=200&height=80&seq=logo-xinmeiti-2026&orientation=landscape',
    quote: '在信息爆炸的时代，五一吃瓜网做到了又快又准，是吃瓜群众最信赖的信息来源之一。',
    date: '2026年5月',
  },
  {
    id: 3,
    outlet: '数字媒体评论',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20media%20review%20brand%20logo%20design%20with%20Chinese%20characters%2C%20clean%20white%20background%2C%20elegant%20editorial%20style%2C%20professional%20identity&width=200&height=80&seq=logo-shuzimeiti-2026&orientation=landscape',
    quote: '深度调查能力令人印象深刻，五一吃瓜网正在重新定义娱乐资讯媒体的行业标准。',
    date: '2026年4月',
  },
];